module.exports = __webpack_public_path__ + "img/two1Blue.27238901.jpg";